import { mustBeCorrectVariableName } from '@builder/utils';
export const transformVariableName = (varName) => {
    if (varName && mustBeCorrectVariableName(varName)) {
        return varName.replaceAll(/^[^a-zA-Z_]+/g, '_$&').replaceAll(/[^a-zA-Z_0-9]+/g, '_');
    }
    return varName || '_';
};
